import type { AxiosInstance } from 'axios';

const ENABLE_API_LOGGING = import.meta.env['VITE_ENABLE_API_LOGGING'] === 'true';

export const Logging = {
  addLoggingInterceptors(axiosInstance: AxiosInstance): void {
    if (!ENABLE_API_LOGGING) return;

    axiosInstance.interceptors.request.use((config) => {
      console.log('=== AXIOS REQUEST ===');
      console.log('URL:', `${config.baseURL || ''}${config.url || ''}`);
      console.log('Method:', config.method?.toUpperCase());
      console.log('Headers:', JSON.stringify(config.headers, null, 2));
      console.log('Data:', JSON.stringify(config.data));
      console.log('Params:', config.params);
      console.log('=====================');
      return config;
    });

    axiosInstance.interceptors.response.use(
      (response) => {
        console.log('=== AXIOS RESPONSE ===');
        console.log('URL:', `${response.config.baseURL || ''}${response.config.url || ''}`);
        console.log('Method:', response.config.method?.toUpperCase());
        console.log('Status:', response.status);
        console.log('Headers:', response.headers);
        console.log('Data:', JSON.stringify(response.data));
        console.log('=====================');
        return response;
      },
      (error) => {
        console.log('=== AXIOS RESPONSE ERROR ===');
        console.log('URL:', `${error.config?.baseURL || ''}${error.config?.url || ''}`);
        console.log('Method:', error.config?.method?.toUpperCase());
        console.log('Status:', error.response?.status);
        console.log('Status Text:', error.response?.statusText);
        console.log('Headers:', error.response?.headers);
        console.log('Error Data:', JSON.stringify(error.response?.data));
        console.log('Error Message:', error.message);
        console.log('============================');
        return Promise.reject(error);
      }
    );
  },
};

export default Logging;
